import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-12 md:py-24 bg-dark-900" data-id="element-99">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-101">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-102">
            Esta guía <span className="text-earth-green" data-id="element-103">cambia eso.</span>
          </h2>

          <p className="text-xl text-gray-300 mb-12 font-light" data-id="element-104">
            Aquí no vas a encontrar teoría vacía ni recetas complicadas. Vas a
            encontrar un sistema claro para alimentar a tu mascota con comida
            real, casera y adaptada a cada etapa: cachorro, adulto y senior.
          </p>

          <div className="bg-dark-800 p-8 md:p-12 rounded-2xl border border-dark-800 shadow-2xl" data-id="element-105">
            <p className="text-2xl text-white font-serif italic mb-6" data-id="element-106">
              Recetas sencillas, completas y pensadas para que sepas exactamente
              qué le estás dando en cada plato.
            </p>
            <p className="text-earth-amber font-semibold text-lg uppercase tracking-widest" data-id="element-107">
              Pero esto no es solo un recetario.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}